const wowApp = require('angular').module('wowApp.common');

wowApp.directive('wowDialog', ['SettingsService', 'DialogRegistry', require('./dialog.directive')]);



// WEBPACK FOOTER //
// ./src/common/dialog/index.js